import { Component } from '@inter-ikea-core/core';

/**
 * Add this component to entities that you want outlined red by the RedOutlineSystem
 */
export default class RedOutlineComponent implements Component {
  static id = 2066;
  typeId = RedOutlineComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq() {
    return true;
  }
}
